/**
 * Created by Karan variya on 22/12/2018.
 */

import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';



import {HttpManagerService}  from '../httpmanager.service';

@Injectable()
export class AdmincrashreportService {
    constructor(
        private httpmanagerService : HttpManagerService
    ){
    }
    allAdmincrashreport(): Promise<any> {
        return this.httpmanagerService.HttpPost('sadmincrash', "","").then(data =>{
            return data;
        })
    }
    deleteAdmincrashreport(): Promise<any> {
        return this.httpmanagerService.HttpPost('sadmincrash/delete', "","").then(data =>{
            return data;
        })
    }
    
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/api/admincrashreport/admincrashreport.service.ts